import {
    businessOnlineRoutes,
    digitalCreditRoutes,
    newAccountOpeningRoutes,
    newBolProfileRoutes,
    newCustodyAccountRoutes,
    globalMarketAccountRoutes,
    remediationRoutes, tpfaRoutes
} from '../routers/routes'

export const ACCOUNT_OPENING_STEPS = [
    {name: "Entity", path: newAccountOpeningRoutes.newAccount, isSelectable: false},
    {name: "Confirm Details", path: newAccountOpeningRoutes.confirmdetails},
    {name: "Confirm Product", path: newAccountOpeningRoutes.confirmproduct},
    {name: "KYC", path: newAccountOpeningRoutes.kyc},
    {name: "Confirm Authorisers", path: newAccountOpeningRoutes.confirmauthorisers},
    {name: "Complete", path: newAccountOpeningRoutes.confirmapplication},
];

export const CUSTODY_ACCOUNT_STEPS = [
    {name: "Entity", path: newCustodyAccountRoutes.custodyaccount, isSelectable: false},
    {name: "Account Capacity/Type", path: newCustodyAccountRoutes.accountrelations},
    {name: "Beneficial Owner Details", path: newCustodyAccountRoutes.beneficialowner},
    {name: "Address Details", path: newCustodyAccountRoutes.addressdetails},
    {name: "Contact Details", path: newCustodyAccountRoutes.contactdetails},
    {name: "Cash Account Purpose", path: newCustodyAccountRoutes.accountcashpurpose},
    {name: "Instructing Party", path: newCustodyAccountRoutes.instructingparty},
    {name: "Confirm Authorisers", path: newCustodyAccountRoutes.confirmauthorisers},
    {name: "Complete", path: newCustodyAccountRoutes.complete}
];
export const ONBOARDING_NEW_ENTITY_STEPS = [
    {name: 'Lookup', path: '/onboard/lookup', isSelectable: false},
    {name: 'Reg info', path: '/onboard/reginfo', isSelectable: false},
    {name: 'Entity Details', path: '/onboard/details', isSelectable: false},
    {name: 'KYC', path: '/onboard/kyc', isSelectable: false},
    {name: 'Complete', path: '/onboard/confirmed', isSelectable: false},
];

export const NEW_BOL_DOMESTIC_PRFOILE_ON_TAKE = [
    {name: "Entity", path: newBolProfileRoutes.bol, isSelectable: false},
    {name: "Customer Details", path: newBolProfileRoutes.details, isSelectable: false},
    {name: "Channel Products & Services", path: newBolProfileRoutes.channel, isSelectable: false},
    {name: "Levels And Options", path: newBolProfileRoutes.options, isSelectable: false},
    {name: "Banking Accounts", path: newBolProfileRoutes.accounts, isSelectable: false},
    {name: "Users Information", path: newBolProfileRoutes && newBolProfileRoutes.users, isSelectable: false},
    {name: "Complete", path: newBolProfileRoutes.complete, isSelectable: false},
];

export const DIGITAL_CREDIT_STEPS = [
    {name: "Entity", path: digitalCreditRoutes.root},
    {name: "Details", path: digitalCreditRoutes.details},
    {name: "Complete", path: digitalCreditRoutes.complete},
];

export const LEGAL_REMEDIATION = [
    {name: "Entity", path: remediationRoutes.root, isSelectable: false},
    {name: "EBTCs", path: remediationRoutes.legals, isSelectable: false},
    {name: "Complete", path: remediationRoutes.complete, isSelectable: false}
];
export const BUSINESS_ONLINE_PROFILE = [
    {name: "Legal Entity", path: businessOnlineRoutes.businessOnline},
    {name: "Transaction Details", path: businessOnlineRoutes.transaction},
    {name: "Accounts Setup", path: businessOnlineRoutes.accountSetup},
    {name: "Authorization", path: businessOnlineRoutes.authorization},
    {name: "Contact Details", path: businessOnlineRoutes.contactDetails},
    {name: "Complete", path: businessOnlineRoutes.complete}
];
export const TPFA = [
    {name: "Entity", path: tpfaRoutes.root, isSelectable: false},
    {name: "Third Party Details", path: tpfaRoutes.thirdParty, isSelectable: false},
    {name: "Complete", path: tpfaRoutes.complete, isSelectable: false},
];



export const GLOBAL_MARKET_STEPS = [
    {name: "Entity", path: globalMarketAccountRoutes.entity, isSelectable: true},
    {name: "Confirm Entity", path: globalMarketAccountRoutes.confirmentity, isSelectable: true},
    // {name: "Customers", path: globalMarketAccountRoutes.customers, isSelectable: true},
    {name: "Settlement Instructions", path: globalMarketAccountRoutes.instructions, isSelectable: false},
    {name: "Complete", path: globalMarketAccountRoutes.complete},
];
